import React from 'react';
import { useNavigate } from 'react-router-dom';

interface HomeProps {
    storeId: number | null;
}

const missingStoreMessage = '매장 정보가 없습니다. 다시 로그인해 주세요.';

const Home: React.FC<HomeProps> = ({ storeId }) => {
    const navigate = useNavigate();

    const goToProductManagement = () => {
        if (storeId) {
            navigate(`/admin/stores/${storeId}/products`);
        } else {
            alert(missingStoreMessage);
        }
    };

    const goToTableManagement = () => {
        if (storeId) {
            navigate(`/admin/stores/${storeId}/tables`);
        } else {
            alert(missingStoreMessage);
        }
    };

    const goToCategoryManagement = () => {
        if (storeId) {
            navigate(`/admin/stores/${storeId}/categories`);
        } else {
            alert(missingStoreMessage);
        }
    };

    const goToSalesManagement = () => {
        if (storeId) {
            navigate(`/admin/stores/${storeId}/sales`);
        } else {
            alert(missingStoreMessage);
        }
    };

    return (
        <div style={containerStyle}>
            <h1>관리자 대시보드</h1>
            {storeId ? (
                <>
                    <p>현재 관리 중인 매장 ID: {storeId}</p>
                    <div style={buttonContainerStyle}>
                        <button onClick={goToProductManagement} style={buttonStyle}>
                            상품 관리
                        </button>
                        <button
                            onClick={goToTableManagement}
                            style={{ ...buttonStyle, backgroundColor: '#28a745' }}
                            type="button"
                        >
                            테이블 관리
                        </button>
                        <button
                            onClick={goToCategoryManagement}
                            style={{ ...buttonStyle, backgroundColor: '#17a2b8' }}
                        >
                            카테고리 관리
                        </button>
                        <button
                            onClick={goToSalesManagement}
                            style={{ ...buttonStyle, backgroundColor: '#ff6600' }}
                        >
                            매출 관리
                        </button>
                    </div>
                </>
            ) : (
                <p>{missingStoreMessage}</p>
            )}
        </div>
    );
};

const containerStyle: React.CSSProperties = {
    padding: '40px',
    fontFamily: 'sans-serif',
    textAlign: 'center'
};

const buttonContainerStyle: React.CSSProperties = {
    marginTop: '30px',
    display: 'flex',
    justifyContent: 'center',
    gap: '20px'
};

const buttonStyle: React.CSSProperties = {
    padding: '15px 30px',
    fontSize: '18px',
    cursor: 'pointer',
    color: 'white',
    backgroundColor: '#007bff',
    border: 'none',
    borderRadius: '5px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
};

export default Home;
